import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import Typekit from 'react-typekit';

import '../styles/index.scss'

import LOGO from '../img/logo.jpg'
import LOGO_FOOTER from '../img/waterview-logo.png'
import LOGO_GOPHERLABS from '../img/gopherlabs.svg'

import INSTAGRAM from 'react-icons/lib/fa/instagram'
import FACEBOOK from 'react-icons/lib/fa/facebook-square'

import PARTNERS_SKIN_MEDICA from '../img/partners/skinmedica.png'
import PARTNERS_BOTOX from '../img/partners/botox.png'
import PARTNERS_JUVEDERM from '../img/partners/juvederm.png'
import PARTNERS_BD from '../img/partners/bd.png'
import PARTNERS_LATISSE from '../img/partners/latisse.png'
const PARTNERS = [
  {
    image: PARTNERS_SKIN_MEDICA,
    name: "Skin Medica",
    link: "http://www.skinmedica.ca/"
  },
  {
    image: PARTNERS_BOTOX,
    name: "BOTOX®",
    link: "https://www.botoxcosmetic.com/"
  },
  {
    image: PARTNERS_JUVEDERM,
    name: "JUVEDERM®: Dermal fillers for lips, face and cosmetic treatment",
    link: "https://www.juvederm.ca/en/"
  },
  {
    image: PARTNERS_BD,
    name: "BRILLIANT DISTINCTIONS®",
    link: "https://www.brilliantdistinctions.ca/"
  },
  // {
  //   image: PARTNERS_LATISSE,
  //   name: "LATISSE®",
  //   link: "http://www.latisse.ca/"
  // }
]

let ReactTypeformEmbed

const isBrowser = typeof window !== 'undefined'
if (isBrowser) {
  ReactTypeformEmbed = isBrowser ? require('react-typeform-embed').ReactTypeformEmbed : null
}

class HeaderAddon extends React.Component {
  render() {
    return (
      <span>
        <div className="columns hero-content">
          <div className="column half-left">
            <div className="container-half half-left">
              <div className="cont">
                <h1>Waterview Medical Rejuvenation for the best version of YOU</h1>
                <p>
                  Our doctors take the time to hear your concerns and develop a medical treatment plan based on your Rejuvenation goals.
                  </p>
                <a href="#contacts" className="button is-primary">Get Started</a>
              </div>
            </div>
          </div>

          <div className="column half-right">
          </div>
        </div>

        <div id="partners">
          <div className="container">
            <div className="columns is-mobile">
              {PARTNERS.map((logo, index) =>
                <div className="column is-one-fifth" key={`partner-logo-${index}`}>
                  <a href="#" target="_blank" rel="nofollow">
                    <img src={logo.image} alt="Title" />
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </span>
    )
  }
}

class Footer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const location = isBrowser ? window.location : null
    return (
      <div id="footer">
        <div className="container">
          <div className="columns">
            <div className="column is-8">
              <div className="logo">
                <img src={LOGO_FOOTER} />
              </div>

              <div className="content">
                <span>Waterview Medical Rejuvenation</span>
                <p>&#169; All Rights Reserved, 2019</p>
              </div>
            </div>

            <div className="column is-4 actions">
              {/* {location && location.pathname.indexOf('/contact-us') === -1 &&
                <Link to={'/'} className="button is-dark">
                  Contact Us
              </Link>
              } */}
            </div>
          </div>
        </div>

        <a href="https://gopher.it" target="_blank">
          <div id="gopherlabs">
            <span className="text">
              Crafted by
              </span>

            <img src={LOGO_GOPHERLABS} />
          </div>
        </a>
      </div>
    )
  }
}

class TemplateWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hamburgerOpened: false
    };

    if (isBrowser) {
      window.requestAppointment = this.openForm.bind(this);
    }
  }

  _handleHamburgerToggle = (event) => {
    if (event) event.preventDefault();

    this.setState({
      ...this.state,
      hamburgerOpened: !this.state.hamburgerOpened
    })
  }

  openForm(e) {
    if (e) {
      e.preventDefault()
    }

    this.typeformEmbed.typeform.open()
  }

  render() {
    const { children, transition, location } = this.props
    const { hamburgerOpened } = this.state
    const transitionStyles = transition ? transition.style : {}
    const isHome = location.pathname === "/"
    const HeaderEl = (hamburgerHandler) => (
      <div className="site-header"
        style={{
          ...transitionStyles
        }}>
        <div className="header-nav">
          <div className="container">
            <Link to={''}>
              <img src={LOGO} className="logo" />
            </Link>

            <a className="hamburger" onClick={hamburgerHandler}>
              <div></div>
              <div></div>
              <div></div>
            </a>
          </div>
        </div>
        {isHome &&
          <HeaderAddon />
        }
      </div>
    )

    return (
      <div>
        <Helmet
          title="Waterview Medical Rejuvenation"
          meta={[
            { name: 'description', content: 'Multi-disciplinary services facilitated by trained and accredited professionals' },
            { name: 'keywords', content: '' },
          ]}
        />

        <Typekit kitId="trz5wuk" />
        <div className={"overlay" + (hamburgerOpened ? " open" : "")}>
          <div className="container">
            <a href="#" onClick={this._handleHamburgerToggle.bind(this)}>
              <div className="close">
                <span className="first"></span>
                <span className="second"></span>
              </div>
            </a>
          </div>

          <div className="content">
            <ul>
              <li onClick={this._handleHamburgerToggle}>
                <Link to='/'>
                  Home
                </Link>
              </li>

              <li onClick={this._handleHamburgerToggle}>
                <Link to='/services'>
                  Services
                </Link>
              </li>

              <li style={{ marginTop: 15 }}>
                <a href="https://www.instagram.com/waterviewmedicalrejuvenation/" target="_blank" style={{ marginRight: 10 }}>
                  <INSTAGRAM />
                </a>

                {/* <a href="#" target="_blank">
                  <FACEBOOK />
                </a> */}
              </li>
            </ul>
          </div>
        </div>

        <div className={"content-wrapper" + (hamburgerOpened ? " hamburger-opened" : "")}>
          {HeaderEl(this._handleHamburgerToggle.bind(this))}

          {children()}

          <Footer />
        </div>

        {isBrowser &&
          <ReactTypeformEmbed
            popup={true}
            autoOpen={false}
            url={'https://gopher1.typeform.com/to/XF2GXO'}
            hideHeaders={true}
            hideFooter={true}
            buttonText="Go!"
            style={{ top: 100, display: "none" }}
            ref={(tf => this.typeformEmbed = tf)}
          />
        }
      </div>
    )
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js